import React from 'react'
import { atom } from 'recoil';




export const atomobj=atom({



    key:'aaa',
    default:"RECOILATOMISEMPTY"
})

export default function C() {



  return (
  <>
  


  
  
  </>
  )
}
